export enum TicketContactPreference {
  EmailPreference = 'Email_preference',
  PhonecallPreference = 'Phonecall_preference'
}
